import * as fromDatatype from '../../../../../models/datatype-library';
import { PmtStmtLineDto } from './pmt-stmt-line-dto.model'

export class PmtStmtHdrDto {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_ocr_guid: fromDatatype.GuidDataFieldInterface;
    scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    company_name: fromDatatype.VarcharDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface; // Assuming this maps to a string enum or varchar
    confidence_level: fromDatatype.NumericDatatypeInterface;
    algorithm_provider: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    b2b_matching_status: fromDatatype.VarcharDatatypeInterface;
    einvoice_matching_status: fromDatatype.VarcharDatatypeInterface;
    lines: PmtStmtLineDto[]; // Assuming this refers to another DTO
  }
  